// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".end-test>div[data-v-4892a0be]{padding:.7rem 0}.end-test .end-button[data-v-4892a0be]{padding:2rem 0}.end-test .green[data-v-4892a0be]{color:#2cb774;font-weight:700}", ""]);
// Exports
module.exports = exports;
